import React, { useState, useContext, useEffect, useRef } from "react";


import { globalContext } from '_context/LayoutContext';
import { MapContext } from '_context/MapContext';

import {useToggle,useSetLocation} from '_context/commonHooks';
import util from 'common/util';
import { getItem } from '_services/agent';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import {ollehModule} from '../../common/mapAPIExport'

const objMapType=[
  {value:0,label:'일반지도',icon:'basic',title:'일반',type:"ROADMAP"},
  {value:1,label:'항공지도',icon:'airView',title:'항공',type:"SATELLITE"},
  {value:2,label:'하이브리드',icon:'basicAir',title:'하이브리드',type:"HYBRID"}
];

const POPLanguage = ({onChange}) => {
  const { toggleLang } = useContext(globalContext);

  const chgIsLang = (value) => {   
    toggleLang(value);
    onChange();
  }

    return (
        <div className="list">
            <ul>
                <li><button onClick={() => chgIsLang("KR")}><span>KR</span></button></li>
                <li><button onClick={() => chgIsLang("EN")}><span>EN</span></button></li>
            </ul>
        </div>
    )
}


const Top = () => {
    const [isLang, setIsLang] = useToggle(false);
    const [isLogin, setIsLogin] = useState(false);
    const [mapType, setMapType] = useState({type:0,toggle:false});
    const [grayMode, setGray] = useState({mode:false,toggle:false});

    const [siDo, setSiDo] = useState('');
    const [siGunGu, setSiGunGu] = useState('');
    const [eupMyeonDong, setEupMyeonDong] = useState('');
    const [siDoArr, setSiDoArr] = useState([]);
    const [siGunGuArr, setSiGunGuArr] = useState([]);
    const [eupMyeonDongArr, setEupMyeonDongArr] = useState([]);
    const [selectVisible, setSelectVisible] = useState('none');
    const siDoRef = useRef();
    const siGunGuRef = useRef();
    const eupMyeonDongRef = useRef();

    const { lang,setLocation, } = useContext(globalContext);
    const {  ktMapIns } = useContext(MapContext);

    useEffect(() => {
      if(grayMode.toggle){
        setSelectVisible('none')
        setMapType({...mapType,toggle:false})
      }
    }, [grayMode]);

    useEffect(() => {
      if(mapType.toggle){
        setSelectVisible('none')
        setGray({...grayMode,toggle:false})
      }
    }, [mapType]);

    useEffect(() => {
      if(selectVisible==='block'){
        setMapType({...mapType,toggle:false})
        setGray({...grayMode,toggle:false})
      }
    }, [selectVisible]);

    useEffect(() => {
        if(ktMapIns!=null && ktMapIns instanceof Object){
          getSido()
          ktMapIns.onEvent('idle', function (event, payload) {
            currentAdministrative()
          });
          ktMapIns.onEvent('click', function (event, payload) {
            setSelectVisible('none')
          });
          ktMapIns.onEvent('mousewheel', function (event, payload) {
            setSelectVisible('none')
          });
          ktMapIns.onEvent('rightclick', function (event, payload) {
            setSelectVisible('none')
          });
        }
    }, [ktMapIns]);

    async function  currentAdministrative(selPoint){
      let point = selPoint?selPoint:ollehModule.maps.LatLng.valueOf(ktMapIns.getCenter());
      await getItem('geocode','?point.lat='+point.y+'&point.lng='+point.x, null, 'GET')
      .then(res => {
          let placeAdddres = null
          if(res.data.residentialAddress[0].parcelAddress && res.data.residentialAddress[0].parcelAddress.length>0){
            placeAdddres = res.data.residentialAddress[0].parcelAddress[0]
          }
          if(placeAdddres.siDo){
            setSiDo(placeAdddres.siDo)
          }
          if(placeAdddres.siGunGu){
            setSiGunGu(placeAdddres.siGunGu)
          }else{
            setSiGunGu("전체")
          }
          if(placeAdddres.eupMyeonDong){
            setEupMyeonDong(placeAdddres.eupMyeonDong)
          }
      })
      .catch(err => {})
    }

    useEffect(() => {
      if(ktMapIns!=null && ktMapIns instanceof Object){
        getSiGunGu()
      }
    }, [siDo]);

    useEffect(() => {
      if(ktMapIns!=null && ktMapIns instanceof Object){
        getEupMyeonDong()
      }
    }, [siGunGu]);

    useEffect(() => {
      scrollCorrect(false, true, true)
    }, [siGunGuArr]);

    useEffect(() => {
      scrollCorrect(false, false, true)
    }, [eupMyeonDongArr]);

    useEffect(() => {
      if(selectVisible=='block'){
        let timer = setInterval(function() {
          clearInterval(timer);
          scrollCorrect()
        },100)
      }
    }, [selectVisible]);

    async function  getSido(){
      await getItem('stepbystep','', null, 'GET')
      .then(res => {
        setSiDoArr(res.data.address)
      })
      .catch(err => {console.log(err)})
    }

    async function  getSiGunGu(selSiDo){
      let _sido = selSiDo?selSiDo:siDo
      await getItem('stepbystep',encodeURI(`?siDo=${_sido}&numberOfResults=1000`), null, 'GET')
      .then(res => {
        setSiGunGuArr(res.data.address)
      })
      .catch(err => {console.log(err)})
    }

    async function  getEupMyeonDong(){
      await getItem('stepbystep',encodeURI(`?siDo=${siDo}&siGunGu=${siGunGu}&numberOfResults=1000`), null, 'GET')
      .then(res => {
        setEupMyeonDongArr(res.data.address)
      })
      .catch(err => {console.log(err)})
    }

    const scrollCorrect = (siDoYN=true, siGunGuYN=true, eupMyeonDongYN=true)=>{
      if(siDoYN){
        let siDoMatchCnt = 0
        siDoArr.some((ele, idx1) => {
          if(siDo == ele.siDo){
            siDoMatchCnt = idx1
            return true;
          }
        })
        siDoRef.current.osInstance().scroll({ x:0, y:siDoMatchCnt*(29)})
      }

      if(siGunGuYN){
        let siGunGuMatchCnt = 0
        siGunGuArr.some((ele, idx2) => {
          if(siGunGu == ele.siGunGu){
            siGunGuMatchCnt = idx2
            return true;
          }
        })
        siGunGuRef.current.osInstance().scroll({ x:0, y:siGunGuMatchCnt*(29)})
      }

      if(eupMyeonDongYN){
        let eupMyeonDongMatchCnt = 0
        eupMyeonDongArr.some((ele, idx3) => {
          if(eupMyeonDong == ele.eupMyeonDong){
            eupMyeonDongMatchCnt = idx3
            return true;
          }
        })
        eupMyeonDongRef.current.osInstance().scroll({ x:0, y:eupMyeonDongMatchCnt*(29)})
      }
    }

    const selectSiDo = (_selSiDo)=>{
      currentAdministrative({y:_selSiDo.geographicInformation.point.lat, x:_selSiDo.geographicInformation.point.lng})
    }

    const selectSiGunGu = (_selSiGunGu)=>{
      currentAdministrative({y:_selSiGunGu.geographicInformation.point.lat, x:_selSiGunGu.geographicInformation.point.lng})
    }

    const selectEupMyeonDong = (_selEupMyeonDong)=>{
      setEupMyeonDong(_selEupMyeonDong.eupMyeonDong)
    }

    const goAdministrative = ()=>{
      let center = ktMapIns.getCenter()
      eupMyeonDongArr.some((ele, idx3) => {
        if(eupMyeonDong == ele.eupMyeonDong){
          center.x = ele.geographicInformation.utmkPoint.x
          center.y = ele.geographicInformation.utmkPoint.y
          return true;
        }
      })
      ktMapIns.setCenter(center)
    }

    const setMap = (name,value) => {
      if(name==="type"){
        ktMapIns.setMapTypeId(objMapType[value].type);
       setMapType({
          type:value,
          toggle:false
        })
      }else{
        setMapType({
          ...mapType,
          [name]:value
        })
      }

    }

    const setGrayMode = (name,value) => {

      if(name==="mode"){
        ktMapIns.grayMode(value);
        setGray({
          mode:value,
          toggle:false
        })
      }else{
        setGray({
          ...grayMode,
          [name]:value
        })
      }
    }

    function setPosition(position) {
      setLocation({latitude:position.coords.latitude,longitude:position.coords.longitude})
    }

    return (
      <React.Fragment>

      <div className="wrapLogin">
      <div className="myAccessLoc">
        <button className="btnsBg" onClick={()=>util.getCurrentLocation(setPosition)}>내 접속위치</button>
      </div>
      <div className="locationSettings">
        <div className="address">
          <a  className="current" onClick={()=>{selectVisible=='none'?setSelectVisible('block'):setSelectVisible('none');}}>
            <span>{siDo}</span>
            <span>{siGunGu}</span>
            <span>{eupMyeonDong}</span>
          </a>
          <div className="lyBox adrsSelect" style={{display:selectVisible}}>
          <div className="inner">
            <div className="choice">
              <div className="plugin-scrollbar-bd">
                <div className="plugin-scrollbar os-host os-theme-dark os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-transition os-host-overflow os-host-overflow-y">
                  <div className="os-resize-observer-host">
                    <div className="os-resize-observer observed" style={{ left: 0, right: "auto" }}/>
                  </div>
                  <div className="os-size-auto-observer" style={{ height: "calc(100% + 1px)", float: "left" }}>
                    <div className="os-resize-observer observed" />
                  </div>
                  <div className="os-content-glue" style={{ margin: 0 }} />
                  <div className="os-padding">
                  <OverlayScrollbarsComponent ref={siDoRef} style={{ maxHeight: 216 }} >
                    {siDoArr.map((address)=><a key={address.siDo} style={{backgroundColor:siDo==address.siDo?'#ddd':'#fff'}} onClick={()=>selectSiDo(address)}>{address.siDo}</a>)}    
                  </OverlayScrollbarsComponent> 
                  </div>
                </div>
              </div>
            </div>
            <div className="choice">
              <div className="plugin-scrollbar-bd">
                <div className="plugin-scrollbar os-host os-theme-dark os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-transition os-host-overflow os-host-overflow-y">
                  <div className="os-resize-observer-host">
                    <div className="os-resize-observer observed" style={{ left: 0, right: "auto" }}/>
                  </div>
                  <div className="os-size-auto-observer" style={{ height: "calc(100% + 1px)", float: "left" }}>
                    <div className="os-resize-observer observed" />
                  </div>
                  <div className="os-content-glue" style={{ margin: 0 }} />
                  <div className="os-padding">
                  <OverlayScrollbarsComponent ref={siGunGuRef} style={{ maxHeight: 216 }} >
                    {siGunGuArr.map((address)=><a key={address.siGunGu} style={{backgroundColor:siGunGu==address.siGunGu?'#ddd':'#fff'}} onClick={()=>selectSiGunGu(address)}>{address.siGunGu}</a>)}  
                  </OverlayScrollbarsComponent> 
                  </div> 
                </div>
              </div>
            </div>
            <div className="choice">
              <div className="plugin-scrollbar-bd">
                <div className="plugin-scrollbar os-host os-theme-dark os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-scrollbar-vertical-hidden os-host-transition">
                  <div className="os-resize-observer-host">
                    <div className="os-resize-observer observed" style={{ left: 0, right: "auto" }}/>
                  </div>
                  <div className="os-size-auto-observer"style={{ height: "calc(100% + 1px)", float: "left" }}>
                    <div className="os-resize-observer observed" />
                  </div>
                  <div className="os-content-glue" style={{ margin: 0 }} />
                  <div className="os-padding">
                  <OverlayScrollbarsComponent ref={eupMyeonDongRef} style={{ maxHeight: 216 }} >
                    {eupMyeonDongArr.map((address)=><a key={address.eupMyeonDong} style={{backgroundColor:eupMyeonDong==address.eupMyeonDong?'#ddd':'#fff'}} onClick={()=>selectEupMyeonDong(address)}>{address.eupMyeonDong}</a>)} 
                  </OverlayScrollbarsComponent> 
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="btnWrap">
            <button className="btnCancel" onClick={()=>{setSelectVisible('none'); currentAdministrative()}}>
              <span>취소</span>
            </button>
            <button className="btnSubmit"  onClick={()=>{setSelectVisible('none'); goAdministrative()}}>
              <span>확인</span>
            </button>
          </div>
        </div>
        </div>
        {/* <div className="weatherWrap">
          <a  className="current">
            <span className="temperature">20℃</span>
            <span className="dust lv4">{' '}매우나쁨</span>
          </a>
        </div> */}
      </div>
      <div className="modChange">
        <div className={!mapType.toggle?"mapType":"mapType open"}>
          <button  onClick={() => setMap("toggle",!mapType.toggle)}>
            <span className={"iconMap "+objMapType[mapType.type].icon}>
            </span>
            <span>{objMapType[mapType.type].title}</span>
            <span className="iconMap icAr">열기/닫기</span>
          </button>
          {
            mapType.toggle && 
            <div className="list" style={{width:'80px'}}>
            <ul>
            {
              objMapType.map((item,i)=>{
                return(
                  <li key={i}><button onClick={()=>setMap("type",item.value)}><span className={"iconMap "+item.icon}></span>{item.label}</button></li>
                )
              })
            }
            </ul>
          </div>
          }
         
        </div>
        <div className={!grayMode.toggle?"grayMode":"grayMode open"}>
        <button  onClick={() => setGrayMode("toggle",!grayMode.toggle)}>
            <span>{grayMode.mode?"흑백":"기본"}</span>
            <span className="iconMap icAr">열기/닫기</span>
                  </button>
                 { grayMode.toggle && 
                  <div className="list">
                    <ul>
                        <li><button onClick={() => setGrayMode("mode",false)}><span>기본</span></button></li>
                        <li><button onClick={() => setGrayMode("mode",true)}><span>흑백</span></button></li>
                    </ul>
                </div> 
            }
        </div>


        {/* <div className={!isLang?"language":"language open"}>
				<button onClick={() => setIsLang()}>
					<span>{lang}</span>
					<span className="iconMap icAr">열기/닫기</span>
                </button>
               { isLang && <POPLanguage onChange={() => setIsLang()} /> }
        </div> */}
     
      </div>
      <div className="myInfo">
        <a className="myphoto" onClick={() => setIsLogin(!isLogin)}></a>
        { isLogin &&
        <div className="boxPos">
          <div className="boxStyle snsLogin">
            <div className="title">소셜 간편 로그인</div>
            <div className="snsList">
              <a >
                <span className="iconsBg ic_naver"></span>네이버 아이디로 로그인
              </a>
              <a >
                <span className="iconsBg ic_kakao"></span>카카오 아이디로 로그인
              </a>
              <a >
                <span className="iconsBg ic_facebook"></span>페이스북 아이디로 로그인
              </a>
              <a >
                <span className="iconsBg ic_google"></span>구글 아이디로 로그인
              </a>
            </div>
            <div className="tx1">원내비와 동일한 소설계정으로 로그인하시면 <br/> 원내비와 연계된 서비스를 이용할 수 있습니다.</div>
            <div className="certKey">
              <div className="tx2">KT Geo master 기업회원이신가요.</div>
              <div className="inner">
                <textarea name="" id="" placeholder="Geo master 인증키를 입력하세요."></textarea>
                <button><span>로그인</span></button>
              </div>
            </div>
            <button className="btnsBg btnClose" onClick={() => setIsLogin(!isLogin)}>닫기</button>
          </div>

        </div>
    }
      </div>
    </div>

        </React.Fragment>
    );
  };
  
  export default Top;